import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import Select, { StylesConfig, components } from 'react-select';
import clsx from 'clsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import '../Project.css'
import fetchAPI from '../../../common/fetchAPI';
import ProjectResource from '../resources/ProjectResource';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { updateIsLoading as getMethodFromTasksSlice, reloadProjectSummaryTab } from '../TasksSlice'
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    getProjectTeam, getSelectedProjectTeamMember, addAccountProject, updateAccountProject, updateIsLoading, resetProjectTeam, updateAccountProjectId
} from '../projectSlice';
import { formatNumberCustomoriginalapiforclient, determineCommaSeprater, parseLocalizedNumber, formatNumberCustomoriginalapiv2, formatNumberCustomoriginal, validateCultureNumber, dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import { AttachmentUpload } from '../../attachment/AttachmentUpload';
import { addAttachment } from '../../attachment/AttachmentSlice';
import GetAttachments from '../../attachment/AttachmentItem';
import CanvasLoader from '../../../common/CanvasLoader';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import infoSVG from "../../../assets/image/info-SVG.svg"
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';
import { ShowSwalWithConfirmation, ShowSwalWithConfirmationMessage } from '../../../common/SweetAlert';

interface DropdownItem {
    value: number;
    label: string;
}

const objDropdown = {
    clientName: [],
    teamLead: [],
    projectManager: [],
    timesheetApprovalType: [],
    expenseApprovalType: [],
    billingType: [],
    projectBillingRateType: [],
    projectStatus: [],
    projectType: [],
    clientContact: [],
    ClientDepartment: [],
    projectTemplates: [],
    projectTeam: [],
    accountRole: []
}

const objProjectValues = {
    AccountClientId: 0,
    // ProjectCode: "",
    LeaderEmployeeId: 0,
    ProjectManagerEmployeeId: 0,
    TimesheetApprovalTypeId: 0,
    ExpenseApprovalTypeId: 0,
    DefaultBillingRate: 0,
    ProjectBillingTypeId: 0,
    ProjectBillingRateTypeId: 0,
    FixedCost: 0,
    isDisabled: false,
    projectDescription: "",
    EstimatedDuration: 0,
    ProjectEstimatedCost: 0,
    ProjectStatusId: 0,
    AccountProjectTypeId: 0,
    StartDate: new Date(),
    Deadline: new Date(),
    AccountClientContactId: 0,
    AccountClientDepartmentId: 0,
    AccountProjectId: 0,
    IsShowProjectTeam: true,
    isCanvasLoader: false,
    ProjectPrefix : "",
    AutoIncludeProjectEmployeesInTasks : false,
    projectYup: {
        projectName: "", projectCode: "", projectDescription: "", AccountProjectTemplateId: "",
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: "",
        CustomField10: "",
        CustomField11: "",
        CustomField12: "",
        CustomField13: "",
        CustomField14: "",
        CustomField15: ""
    }
}

const ProjectAddUpdate = (props: any) => {
    const { IsLicenseExpired, IsFromSummary } = props;
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const dispatch = useAppDispatch();
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fromValue = queryParams.get('from');
    const [tab, setTab] = useState('Basic');
    const [projectResponse, setProjectResponse] = useState<any | ''>(objDropdown);
    const [projectValues, setprojectValues] = useState<any | ''>(objProjectValues);
    const { accountprojectid, projectTeamList, isFromTemplate, addProjectTeamList, deletedProjectTeamList, autoGenerateProjectCode,
        autoProjectCode, projectCodePrefix, includeCurrentYearInProjectCode, showClientDepartmentInProject, automaticallyIncludeAdminitratorInProjectTeam,
        isProjectTemplateMandatory, isTemplate, selectedRecord, renderFromSummary } = useAppSelector((state) => state.project);
    const { decimalPlaces, sessionAccountEmployeeId, maxMenuHeight, sessionAccountId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, calendarStartDay,enableUploadFeature } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const attachmentUploadClearRef = useRef<any>(null);
    const [dataTL, setDataTL] = useState<DropdownItem[]>([]);
    const [dataPM, setDataPM] = useState<DropdownItem[]>([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMoreTL, setHasMoreTL] = useState(true);
    const [hasMorePM, setHasMorePM] = useState(true);
    const [selectedTL, setSelectedTL] = useState<DropdownItem | null>(null);
    const [selectedPM, setSelectedPM] = useState<DropdownItem | null>(null);
    const loadedIds = useRef(new Set());
    const [search, setSearch] = useState<string>('');
    const [isSearchTL, setIsSearchTL] = useState(false);
    const [isSearchPM, setIsSearchPM] = useState(false);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const formikRef = useRef<any>(null);
    const [showErrorSummary, setShowErrorSummary] = useState(false);
    const pathName = location.pathname || '';
    const [serverError, setServerError] = useState('');
    const projectCodeRef = useRef<HTMLInputElement>(null);
    //let IsLicenseExpired = localStorage.getItem('IsLicenseExpired');
    useEffect(() => {
        dispatch(resetProjectTeam());
        getCustomFieldTemplateByMasterEntityTypeIdAsync().then((result) => {
            renderProjectFields(accountprojectid, result).then((result) => {
                dispatch(accountprojectid === 0 ? getProjectTeam() : getSelectedProjectTeamMember(accountprojectid));
            }).catch((error) => {
            });
        }).catch((error) => {
        });
        setTab('Basic');
        clearAttachmentUpload();
    }, [selectedRecord, accountprojectid, renderFromSummary]);

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = '13DBFF37-A092-4AE2-A919-775CBED0EDC0';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    const fetchData = async (pageNum: any, search: string) => {
        setLoading(true);
        try {
            const searchParam = search ? `&search=${search}` : "";
            const response: any = await fetchAPI(`api/V2/Projects/GetAccountEmployeesNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${pageNum}${searchParam}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            const newItemsTL = transformedData.filter((item: any) => !dataTL.some((existingItem: any) => existingItem.value === item.value));
            // setDataTL((prevData) => [...prevData, ...newItemsTL]);
            setDataTL((prevData) => {
                const allData = [...prevData, ...newItemsTL];
                const uniqueData = Array.from(new Map(allData.map(item => [item.value, item])).values());
                return uniqueData;
            });
            // setHasMoreTL(newItemsTL.length > 0);
            if(isSearchTL === false){
                 setHasMoreTL(newItemsTL.length > 0);
            } 
            const newItemsPM = transformedData.filter((item: any) => !dataPM.some((existingItem: any) => existingItem.value === item.value));
            // setDataPM((prevData) => [...prevData, ...newItemsPM]);
            setDataPM((prevData) => {
                const allData = [...prevData, ...newItemsPM];
                const uniqueData = Array.from(new Map(allData.map(item => [item.value, item])).values());
                return uniqueData;
            });
            // setHasMorePM(newItemsPM.length > 0);
            if(isSearchPM === false){
                setHasMorePM(newItemsPM.length > 0);
            } 
            setIsSearchTL(false);
            setIsSearchPM(false);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData(page, search);
    }, [page, search]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        // const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
        const el = e.currentTarget;
        const bottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;
        setSearch('');
        if (bottom && hasMoreTL && !loading) {
            setPage((prevPage) => prevPage + 1);
        } else if (bottom && hasMorePM && !loading) {
            setPage((prevPage) => prevPage + 1);
        }
    }

    const customMenuList = (props: any) => {
        const { children, innerRef, maxHeight, getValue } = props;
        const handleMenuScroll = (e: React.UIEvent<HTMLDivElement>) => {
            handleScroll(e);
        }
        return (
            <div onScroll={handleMenuScroll} ref={innerRef} style={{ maxHeight, overflowY: 'auto' }}>
                {children}
            </div>
        );
    }

const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        
        // Safety check if field definition is not found
        if (!foundItem) return customFieldData;

        if (foundItem.MasterCustomDataTypeName === 'Date') {
            return customFieldData;
        } 
        else if (foundItem.MasterCustomDataTypeName === 'Number') {
            if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, decimalPlaces);
            }
            return customFieldData;
        } 
        else {
            return customFieldData;
        }
    }

    const getDefaultValOfSpecificCustomField = (customField: string, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        if (foundItem) {
            // return foundItem.MasterCustomDataTypeName === 'Date' ? moment().format(CurrentCultureDateFormat.toUpperCase()) : (foundItem.DefaultValue || '');
            return foundItem.MasterCustomDataTypeName === 'Date' ? moment(new Date()).format(customFieldInsertionFormat) : (foundItem.DefaultValue || '');
        } else {
            return '';
        }
    }

        const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsArray.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const renderProjectFields = async (AccountProjectId: number, customFields: any) => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        setprojectValues({
            ...projectValues,
            isCanvasLoader: true
        });
        const response = await fetchAPI('api/V2/Projects/GetAllDataInSingleRequest?AccountProjectId=' + AccountProjectId, 'Get', '', true);
        const json = await response.json();
        
        json["Account Project Billing Rate Type"].map((item: any) => {
            item.value = item.SystemProjectBillingRateTypeId;
            item.label = item.SystemProjectBillingRateType;
            delete item.SystemProjectBillingRateTypeId;
            delete item.SystemProjectBillingRateType;
        });
        json["Project Status"].map((item: any) => {
            item.value = item.AccountStatusId;
            item.label = item.Status;
            delete item.AccountStatusId;
            delete item.Status;
        });
        json["Project Type"].map((item: any) => {
            item.value = item.AccountProjectTypeId;
            item.label = item.ProjectType;
            delete item.AccountProjectTypeId;
            delete item.ProjectType;
        });
        json["Time Off Approval Type From Timesheet"].map((item: any) => {
            item.value = item.AccountApprovalTypeId;
            item.label = item.ApprovalTypeName;
            delete item.AccountApprovalTypeId;
            delete item.ApprovalTypeName;
        });
        json["Time Off Approval Type From Expense"].map((item: any) => {
            item.value = item.AccountApprovalTypeId;
            item.label = item.ApprovalTypeName;
            delete item.AccountApprovalTypeId;
            delete item.ApprovalTypeName;
        });
        json["ProjectManager"].map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.FullName;
            delete item.AccountEmployeeId;
            delete item.FullName;
        });
        json["TeamLead"].map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.FullName;
            delete item.AccountEmployeeId;
            delete item.FullName;
        });
        json["AccountProjectBillingType"].map((item: any) => {
            item.value = item.AccountBillingTypeId;
            item.label = item.BillingType;
            delete item.AccountBillingTypeId;
            delete item.BillingType;
        });
        json["Clients"].map((item: any) => {
            item.value = item.AccountClientId;
            item.label = item.ClientName;
            delete item.AccountClientId;
            delete item.ClientName;
        });
        json["Account Party Contact"].map((item: any) => {
            item.value = item.AccountPartyContactId;
            item.label = item.FirstName;
            delete item.AccountPartyContactId;
            delete item.FirstName;
        });
        json["Account Party Department"].map((item: any) => {
            item.value = item.AccountPartyDepartmentId;
            item.label = item.PartyDepartmentName;
            delete item.AccountPartyDepartmentId;
            delete item.PartyDepartmentName;
        });
        json["Account Project Templates"].map((item: any) => {
            item.value = item.AccountProjectId;
            item.label = item.ProjectName;
            delete item.AccountProjectId;
            delete item.ProjectName;
        });
        json["Time Off Approval Type From Timesheet"].unshift({ value: 0, label: 'Approval Not Required' });
        json["Time Off Approval Type From Expense"].unshift({ value: 0, label: 'Approval Not Required' });
        json["Account Party Contact"].unshift({ value: 0, label: 'Select' });
        json["Account Party Department"].unshift({ value: 0, label: 'Select' });
        json["Account Project Templates"].unshift({ value: "", label: 'Select' });
        
        setProjectResponse({
            ...projectResponse,
            projectBillingRateType: json["Account Project Billing Rate Type"],
            billingType: json["AccountProjectBillingType"],
            projectType: json["Project Type"],
            clientName: json["Clients"],
            teamLead: json["TeamLead"],
            projectManager: json["ProjectManager"],
            timesheetApprovalType: json["Time Off Approval Type From Timesheet"],
            expenseApprovalType: json["Time Off Approval Type From Expense"],
            projectStatus: json["Project Status"],
            clientContact: json["Account Party Contact"],
            ClientDepartment: json["Account Party Department"],
            projectTemplates: json["Account Project Templates"],
            accountRole: json["Account Role"]
        });
        
        //const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
                let formattedDefaultBillingRate = '';
        let formattedFixedCost = '';
        let formattedProjectEstimatedCost = '';
        if(accountprojectid != 0){
            if (json["Project"][0].DefaultBillingRate !== null && json["Project"][0].DefaultBillingRate !== undefined) {
                        formattedDefaultBillingRate = Number(json["Project"][0].DefaultBillingRate).toFixed(decimalPlaces);
            }
                        if (json["Project"][0].FixedCost !== null && json["Project"][0].FixedCost !== undefined) {
                        formattedFixedCost = Number(json["Project"][0].FixedCost).toFixed(decimalPlaces);
            }

            if (json["Project"][0].ProjectEstimatedCost !== null && json["Project"][0].ProjectEstimatedCost !== undefined) {
                        formattedProjectEstimatedCost = Number(json["Project"][0].ProjectEstimatedCost).toFixed(decimalPlaces);
            }
            formattedDefaultBillingRate = formatNumberCustomoriginalapiforclient(cultureInfoName.toString(), formattedDefaultBillingRate, decimalPlaces);
            formattedFixedCost = formatNumberCustomoriginalapiforclient(cultureInfoName.toString(), formattedFixedCost, decimalPlaces);
            formattedProjectEstimatedCost = formatNumberCustomoriginalapiforclient(cultureInfoName.toString(), formattedProjectEstimatedCost, decimalPlaces);
/*                 if (isCommaSeparator) {
        formattedDefaultBillingRate = formattedDefaultBillingRate.replace('.', ',');
        formattedFixedCost = formattedFixedCost.replace('.', ',');
    } else if (isCommaSeparator === false) {
        formattedDefaultBillingRate = formattedDefaultBillingRate.replace(',', '.');
        formattedFixedCost = formattedFixedCost.replace(',', '.');
    } */
        }
        setprojectValues({
            ...projectValues,
            projectYup: {
                projectName: accountprojectid != 0 ? json["Project"][0].ProjectName : "",
                ProjectPrefix: accountprojectid != 0 ? json["Project"][0].ProjectPrefix : projectCodePrefix,
                projectCode:  accountprojectid != 0 ? (json["Project"][0].ProjectCode) : (autoGenerateProjectCode ? autoProjectCode : ""),                
                AccountProjectTemplateId: accountprojectid != 0 ? json["Project"][0].projectTemplateId : json["Account Project Templates"][0].value,
                	CustomField1: accountprojectid != 0 ?
                    (json["Project"][0].CustomField1 ? setCustomFieldValues('CustomField1', json["Project"][0].CustomField1, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField1', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField1', customFields),
                    CustomField2: accountprojectid != 0 ?
                    (json["Project"][0].CustomField2 ? setCustomFieldValues('CustomField2', json["Project"][0].CustomField2, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField2', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField2', customFields),
                    CustomField3: accountprojectid != 0 ?
                    (json["Project"][0].CustomField3 ? setCustomFieldValues('CustomField3', json["Project"][0].CustomField3, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField3', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField3', customFields),
                    CustomField4: accountprojectid != 0 ?
                    (json["Project"][0].CustomField4 ? setCustomFieldValues('CustomField4', json["Project"][0].CustomField4, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField4', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField4', customFields),
                    CustomField5: accountprojectid != 0 ?
                    (json["Project"][0].CustomField5 ? setCustomFieldValues('CustomField5', json["Project"][0].CustomField5, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField5', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField5', customFields),
                    CustomField6: accountprojectid != 0 ?
                    (json["Project"][0].CustomField6 ? setCustomFieldValues('CustomField6', json["Project"][0].CustomField6, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField6', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField6', customFields),
                    CustomField7: accountprojectid != 0 ?
                    (json["Project"][0].CustomField7 ? setCustomFieldValues('CustomField7', json["Project"][0].CustomField7, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField7', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField7', customFields),
                    CustomField8: accountprojectid != 0 ?
                    (json["Project"][0].CustomField8 ? setCustomFieldValues('CustomField8', json["Project"][0].CustomField8, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField8', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField8', customFields),
                    CustomField9: accountprojectid != 0 ?
                    (json["Project"][0].CustomField9 ? setCustomFieldValues('CustomField9', json["Project"][0].CustomField9, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField9', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField9', customFields),
                    CustomField10: accountprojectid != 0 ?
                    (json["Project"][0].CustomField10 ? setCustomFieldValues('CustomField10', json["Project"][0].CustomField10, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField10', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField10', customFields),
                    CustomField11: accountprojectid != 0 ?
                    (json["Project"][0].CustomField11 ? setCustomFieldValues('CustomField11', json["Project"][0].CustomField11, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField11', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField11', customFields),
                                        CustomField12: accountprojectid != 0 ?
                    (json["Project"][0].CustomField12 ? setCustomFieldValues('CustomField12', json["Project"][0].CustomField12, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField12', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField12', customFields),
                                        CustomField13: accountprojectid != 0 ?
                    (json["Project"][0].CustomField13 ? setCustomFieldValues('CustomField13', json["Project"][0].CustomField13, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField13', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField13', customFields),
                                        CustomField14: accountprojectid != 0 ?
                    (json["Project"][0].CustomField14 ? setCustomFieldValues('CustomField14', json["Project"][0].CustomField14, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField14', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField14', customFields),
                                        CustomField15: accountprojectid != 0 ?
                    (json["Project"][0].CustomField15 ? setCustomFieldValues('CustomField15', json["Project"][0].CustomField15, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField15', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField15', customFields),

                projectDescription: accountprojectid != 0 ? json["Project"][0].ProjectDescription : ""
            },
            AccountClientId: accountprojectid != 0 ? json["Project"][0].AccountClientId : json["Clients"][0].value,
            AutoIncludeProjectEmployeesInTasks: accountprojectid != 0 ? (json["Project"][0].AutoIncludeProjectEmployeesInTasks) : false,
            // ProjectCode: accountprojectid != 0 ? json["Project"][0].ProjectCode : autoGenerateProjectCode ? autoProjectCode : '',
            // LeaderEmployeeId: accountprojectid != 0 ? json["Project"][0].LeaderEmployeeId : json["TeamLead"][0].value,
            // ProjectManagerEmployeeId: accountprojectid != 0 ? json["Project"][0].ProjectManagerEmployeeId : json["ProjectManager"][0].value,
            TimesheetApprovalTypeId: accountprojectid != 0 ? (json["Project"][0].TimeSheetApprovalTypeId != null ? json["Project"][0].TimeSheetApprovalTypeId : 0) : json["Time Off Approval Type From Timesheet"][0].value,
            ExpenseApprovalTypeId: accountprojectid != 0 ? (json["Project"][0].ExpenseApprovalTypeId != null ? json["Project"][0].ExpenseApprovalTypeId : 0) : json["Time Off Approval Type From Expense"][0].value,            //binding culture
          
            DefaultBillingRate: accountprojectid != 0 ? formattedDefaultBillingRate : 
            '',
            isDisabled: accountprojectid != 0 ? json["Project"][0].IsDisabled : false,
            ProjectBillingTypeId: accountprojectid != 0 ? json["Project"][0].ProjectBillingTypeId : json["AccountProjectBillingType"][0].value,
            ProjectBillingRateTypeId: accountprojectid != 0 ? json["Project"][0].ProjectBillingRateTypeId : json["Account Project Billing Rate Type"][0].value,
            //FixedCost: accountprojectid != 0 ? (json["Project"][0].FixedCost != null ? json["Project"][0].FixedCost : 0) : 0,
            FixedCost: accountprojectid != 0 ? formattedFixedCost : '',
            // projectDescription: accountprojectid != 0 ? json["Project"][0].ProjectDescription : "",
            //EstimatedDuration: accountprojectid != 0 ? json["Project"][0].EstimatedDuration : 0,
            EstimatedDuration: accountprojectid !== 0 && json?.["Project"]?.[0]?.EstimatedDuration != null ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json["Project"][0].EstimatedDuration, 2 ): 0,
            ProjectEstimatedCost: accountprojectid != 0 ? formattedProjectEstimatedCost : '',
            ProjectStatusId: accountprojectid != 0 ? json["Project"][0].ProjectStatusId : json["Project Status"][0].value,
            AccountProjectTypeId: accountprojectid != 0 ? json["Project"][0].AccountProjectTypeId : json["Project Type"][0].value,
            // StartDate: accountprojectid != 0 ? new Date(json["Project"][0].StartDate) : new Date(),
            // Deadline: accountprojectid != 0 ? new Date(json["Project"][0].Deadline) : new Date(),
            // StartDate: accountprojectid != 0 ? dateFormatByAccountCulture(moment.parseZone(new Date(json["Project"][0].StartDate)).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date(),
            // Deadline: accountprojectid != 0 ? dateFormatByAccountCulture(moment.parseZone(new Date(json["Project"][0].Deadline)).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date(),
            StartDate: accountprojectid != 0 ? dateFormatByAccountCulture(moment.parseZone(json["Project"][0].StartDate).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date(),
            Deadline: accountprojectid != 0 ? dateFormatByAccountCulture(moment.parseZone(json["Project"][0].Deadline).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date(),
            // StartDate: accountprojectid != 0 ? dateFormatByAccountCulture(json["Project"][0].StartDate, cultureInfoName.toString()) : new Date(),
            // Deadline: accountprojectid != 0 ? dateFormatByAccountCulture(json["Project"][0].Deadline, cultureInfoName.toString()) : new Date(),
            AccountClientContactId: showClientDepartmentInProject && accountprojectid != 0 ? (json["Project"][0].AccountPartyContactId != null ? json["Project"][0].AccountPartyContactId : 0) : json["Account Party Contact"][0].value,
            AccountClientDepartmentId: showClientDepartmentInProject && accountprojectid != 0 ? (json["Project"][0].AccountPartyDepartmentId != null ? json["Project"][0].AccountPartyDepartmentId : 0) : json["Account Party Department"][0].value,
            IsShowProjectTeam: accountprojectid != 0 ? (json["Project"][0].ProjectBillingRateTypeId === 2 || json["Project"][0].ProjectBillingRateTypeId === 3) ? false : true : true,
            isCanvasLoader: false
        });
        if (accountprojectid != 0) {
            const LeaderId = json["Project"][0].LeaderEmployeeId
            const ProjectManagerId = json["Project"][0].ProjectManagerEmployeeId
            teamLeadEdit(LeaderId);
            projectManagerEdit(ProjectManagerId);
        } else {
            const response: any = await fetchAPI(`api/V2/Projects/GetAccountEmployeesNameAndIdForDropdown/${sessionAccountEmployeeId}?page=${1}&search=${""}`, "GET", "", true);
            const json = await response.json();
            const transformedData = json.items.map((item: any) => ({
                value: item.id,
                label: item.text,
            }));
            setSelectedTL(transformedData[0]);
            setSelectedPM(transformedData[0]);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
    }


    const teamLeadEdit = async (leaderId: any) => {
        let found = false;
        let currentPage = 1;
        setLoading(true);
        setDataTL([]);
        while (!found && hasMoreTL) {
            try {
                const response: any = await fetchAPI(`api/V2/Projects/GetAccountEmployeesNameAndIdForDropdown/${leaderId}?page=${currentPage}&search=${""}`, "GET", "", true);
                const json = await response.json();
                const transformedData = json.items.map((item: any) => ({
                    value: item.id,
                    label: item.text,
                }));
                setDataTL((prevData) => [...prevData, ...transformedData]);
                setHasMoreTL(transformedData.length > 0);
                const targetItem = transformedData.find((item: any) => item.value === leaderId);
                if (targetItem) {
                    setSelectedTL(targetItem);
                    found = true;
                } else {
                    currentPage += 1;
                }
            } catch (error) {
                break;
            } finally {
                setLoading(false);
            }
        }
    }

    const projectManagerEdit = async (ProjectManagerId: any) => {
        let found = false;
        let currentPage = 1;
        setLoading(true);
        setDataPM([]);
        while (!found && hasMorePM) {
            try {
                const response: any = await fetchAPI(`api/V2/Projects/GetAccountEmployeesNameAndIdForDropdown/${ProjectManagerId}?page=${currentPage}&search=${""}`, "GET", "", true);
                const json = await response.json();
                const transformedData = json.items.map((item: any) => ({
                    value: item.id,
                    label: item.text,
                }));
                setDataPM((prevData) => [...prevData, ...transformedData]);
                setHasMorePM(transformedData.length > 0);
                const targetItem = transformedData.find((item: any) => item.value === ProjectManagerId);
                if (targetItem) {
                    setSelectedPM(targetItem);
                    found = true;
                } else {
                    currentPage += 1;
                }
            } catch (error) {
                break;
            } finally {
                setLoading(false);
            }
        }
    }

    const onHandleTextChange = (e: any) => {
        const val = e.target.value;
         if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
             setprojectValues({ ...projectValues, [e.target.name]: e.target.value })
        }
       
        
    }

    const onDateChange = (date: any, name: any) => {
        setprojectValues({
            ...projectValues,
            StartDate: name == "StartDate" ? date : projectValues.StartDate,
            Deadline: name == "DeadlineDate" ? date : projectValues.Deadline
        })
    }

    const onChange = (data: any, filterName: any) => {
        setprojectValues((projectValues: any) => ({
            ...projectValues,
            AccountClientId: filterName.name == "clientArray" ? projectResponse.clientName.filter((x: any) => x.value == data.value)[0].value : projectValues.AccountClientId,
            // LeaderEmployeeId: filterName.name == "teamLeadArray" ? projectResponse.teamLead.filter((x: any) => x.value == data.value)[0].value : projectValues.LeaderEmployeeId,
            // ProjectManagerEmployeeId: filterName.name == "projectManagerArray" ? projectResponse.projectManager.filter((x: any) => x.value == data.value)[0].value : projectValues.ProjectManagerEmployeeId,
            TimesheetApprovalTypeId: filterName.name == "timesheetApprovalTypeArray" ? projectResponse.timesheetApprovalType.filter((x: any) => x.value == data.value)[0].value : projectValues.TimesheetApprovalTypeId,
            ExpenseApprovalTypeId: filterName.name == "expenseApprovalTypeArray" ? projectResponse.expenseApprovalType.filter((x: any) => x.value == data.value)[0].value : projectValues.ExpenseApprovalTypeId,
            ProjectBillingTypeId: filterName.name == "projectBillingTypeArray" ? projectResponse.billingType.filter((x: any) => x.value == data.value)[0].value : projectValues.ProjectBillingTypeId,
            ProjectBillingRateTypeId: filterName.name == "billingRateTypeArray" ? projectResponse.projectBillingRateType.filter((x: any) => x.value == data.value)[0].value : projectValues.ProjectBillingRateTypeId,
            ProjectStatusId: filterName.name == "projectStatusArray" ? projectResponse.projectStatus.filter((x: any) => x.value == data.value)[0].value : projectValues.ProjectStatusId,
            AccountProjectTypeId: filterName.name == "projectTypeArray" ? projectResponse.projectType.filter((x: any) => x.value == data.value)[0].value : projectValues.AccountProjectTypeId,
            AccountClientContactId: filterName.name == "clientContactArray" ? projectResponse.clientContact.filter((x: any) => x.value == data.value)[0].value : projectValues.AccountClientContactId,
            AccountClientDepartmentId: filterName.name == "clientDepartmentArray" ? projectResponse.ClientDepartment.filter((x: any) => x.value == data.value)[0].value : projectValues.AccountClientDepartmentId,
            IsShowProjectTeam: filterName.name == "billingRateTypeArray" ? (projectResponse.projectBillingRateType.filter((x: any) => x.value == data.value)[0].value === 2 || projectResponse.projectBillingRateType.filter((x: any) => x.value == data.value)[0].value === 3) ? false : true : true
        }));
    }

const onSwitch = (data: any) => {
    let switchName = data.target.name;
    const { AutoIncludeProjectEmployeesInTasks, isDisabled } = projectValues;
    const updateState = (name: string, value: boolean) => {
        setprojectValues((prevValues: any) => ({
            ...prevValues,
            [name]: value
        }));
    };

    if (switchName === "AutoIncludeProjectEmployeesInTasks") {
       
        if (!AutoIncludeProjectEmployeesInTasks) {
           ShowSwalWithConfirmation(
                "Are you sure you want to enable this feature?",
                "All current project employees will be added to the project's existing tasks and automatically included in all new tasks. If an employee is manually removed from a task, they will not be automatically added back to that task in the future.",
                "Yes, enable it!",
                "custom-swal-container"
            )
                .then((result) => {
                    if (result) {
                        updateState("AutoIncludeProjectEmployeesInTasks", true);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            updateState("AutoIncludeProjectEmployeesInTasks", false);
        }
    } else if (switchName === "isDisabled") {
        updateState("isDisabled", !isDisabled);
    }
};

    const onAddUpdateProject = (validateValue: any) => {
        IsFromSummary ? dispatch(getMethodFromTasksSlice(true)) : dispatch(updateIsLoading(true));
        const { AccountClientId, ProjectCode, LeaderEmployeeId, ProjectManagerEmployeeId, TimesheetApprovalTypeId, ExpenseApprovalTypeId, DefaultBillingRate,
            ProjectBillingTypeId, ProjectBillingRateTypeId, FixedCost, projectDescription, EstimatedDuration, isDisabled, ProjectEstimatedCost, ProjectStatusId, AccountProjectTypeId,
            StartDate, Deadline, AccountClientContactId, AccountClientDepartmentId
        } = projectValues
        if (accountprojectid == 0) {
            let tempTeam: any[] = [];
            projectTeamList.map((item: any) => {
                if (item.IncludeTeam == 1) {
                    tempTeam.push(item.AccountEmployeeId)
                }
            });
            if (automaticallyIncludeAdminitratorInProjectTeam) {
                projectResponse.accountRole.map((item: any) => {
                    let checkExistance = projectTeamList.filter(x => x.AccountEmployeeId == item.AccountEmployeeId && x.IncludeTeam == 1)[0];
                    if (checkExistance == undefined) {
                        tempTeam.push(item.AccountEmployeeId)
                    }
                });
            }
            let projectPrefix: any
            let tempProjectCode: string
            // if (includeCurrentYearInProjectCode) {
            //     // tempProjectCode = ProjectCode.split('-')[2];
            //     tempProjectCode = validateValue.projectCode.split('-')[2];
            //     projectPrefix = projectCodePrefix == "" ? moment(new Date()).format('YYYY') : projectCodePrefix + '-' + moment(new Date()).format('YYYY');
            // } else {
            //     // tempProjectCode = ProjectCode.split('-')[1];
            //     tempProjectCode = validateValue.projectCode.split('-')[1];
            //     projectPrefix = projectCodePrefix == "" ? "" : projectCodePrefix;
            // }
            if (includeCurrentYearInProjectCode) {
                tempProjectCode = validateValue.projectCode.split('-')[2];
                projectPrefix = projectCodePrefix == "" ? moment(new Date()).format('YYYY') : projectCodePrefix + '-' + moment(new Date()).format('YYYY');
            } else if(projectCodePrefix)  {
                tempProjectCode = validateValue.projectCode.split('-')[1];
                projectPrefix = projectCodePrefix == "" ? "" : projectCodePrefix;
            } else{
                tempProjectCode =  validateValue.projectCode
            }

                                                    // Normalize numeric values before creating object
                                    const normalizedDefaultBillingRate = parseLocalizedNumber(DefaultBillingRate);
                                    const normalizedFixedCost = parseLocalizedNumber(FixedCost);
                                    const normalizedProjectEstimatedCost = parseLocalizedNumber(ProjectEstimatedCost);

            let objectAdd = {
                ProjectName: validateValue.projectName,
                AccountClientId: AccountClientId,
                // ProjectCode: autoGenerateProjectCode ? tempProjectCode : ProjectCode,
                ProjectCode: autoGenerateProjectCode ? tempProjectCode : validateValue.projectCode,
                LeaderEmployeeId: selectedTL?.value,
                ProjectManagerEmployeeId: selectedPM?.value,
                AutoIncludeProjectEmployeesInTasks: projectValues.AutoIncludeProjectEmployeesInTasks,
                // LeaderEmployeeId: LeaderEmployeeId,
                // ProjectManagerEmployeeId: ProjectManagerEmployeeId,
                TimeSheetApprovalTypeId: TimesheetApprovalTypeId,
                ExpenseApprovalTypeId: ExpenseApprovalTypeId,
                DefaultBillingRate: normalizedDefaultBillingRate,
                ProjectBillingTypeId: ProjectBillingTypeId,
                ProjectBillingRateTypeId: ProjectBillingRateTypeId,
                FixedCost: normalizedFixedCost,
                ProjectDescription: validateValue.projectDescription,
                EstimatedDuration: parseLocalizedNumber(EstimatedDuration),                
                ProjectEstimatedCost: normalizedProjectEstimatedCost,
                ProjectStatusId: ProjectStatusId,
                AccountProjectTypeId: AccountProjectTypeId,
                StartDate: moment(StartDate).format(dateInsertionFormat),
                Deadline: moment(Deadline).format(dateInsertionFormat),
                AccountClientContactId: AccountClientContactId,
                AccountClientDepartmentId: AccountClientDepartmentId,
                AccountProjectTemplateId: validateValue.AccountProjectTemplateId,
                ProjectPrefix: validateValue.projectCode ? (autoGenerateProjectCode ? projectPrefix : projectCodePrefix) : "",
                Team: tempTeam.length > 0 ? tempTeam.toString() : sessionAccountEmployeeId.toString(),
                IsTemplate: location.pathname.split('/').filter(Boolean)[0] === 'projects' ? false : true,
                CustomField1: getFormattedCustomField('CustomField1', validateValue.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', validateValue.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', validateValue.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', validateValue.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', validateValue.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', validateValue.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', validateValue.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', validateValue.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', validateValue.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', validateValue.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', validateValue.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', validateValue.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', validateValue.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', validateValue.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', validateValue.CustomField15)
            }
            AccountClientContactId == 0 && delete objectAdd.AccountClientContactId;
            AccountClientDepartmentId == 0 && delete objectAdd.AccountClientDepartmentId;
            validateValue.AccountProjectTemplateId == "" && delete objectAdd.AccountProjectTemplateId;
            TimesheetApprovalTypeId == 0 && delete objectAdd.TimeSheetApprovalTypeId;
            ExpenseApprovalTypeId == 0 && delete objectAdd.ExpenseApprovalTypeId;
            dispatch(addAccountProject(objectAdd)).then((result) => {
                
                if (result.payload.constructor == Array) {
                    setServerError('');
                    const accountProjectId = result.payload[0].id;
                    tempAttachmentId != null && dispatch(addAttachment({ Id: accountProjectId, IsEdit: false, tempAttachmentId: tempAttachmentId, AccountAttachmentTypeId: 4 }))
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    // ShowToast('Success', result.payload[0].message, "success", "toast-top-right");
                    ShowToast('Success', 'Project Added Successfully', "success", "toast-top-right");
                    let objectData = {
                        AccountProjectId: accountProjectId,
                        Deadline: moment(Deadline).format(dateInsertionFormat),
                        IsSummaryFrom: 'View',
                        ProjectBillingRateTypeId: ProjectBillingRateTypeId,
                        ProjectCode: autoGenerateProjectCode ? tempProjectCode : validateValue.projectCode,
                        ProjectName: validateValue.projectName,
                        StartDate:  moment(StartDate).format(dateInsertionFormat),
                        Status: projectResponse.projectStatus.find((item: any)=> item.value === ProjectStatusId).label || ''
                    }
                    localStorage.setItem('objProject', JSON.stringify(objectData));
                    if(pathName === '/accountprojecttemplates'){
                        navigate(`/accountprojectsummary/${accountProjectId}?from=projectTemplate`)
                    }else{
                        navigate(`/accountprojectsummary/${accountProjectId}`)
                    }
                    // setTimeout(() => {
                    //     if (closeButtonRef.current) {
                    //         closeButtonRef.current.click();
                    //     }
                    // });
                    // if (ProjectBillingRateTypeId === 2) {
                    //     navigate('/accountprojectrole', {
                    //         state: {
                    //             "AccountProjectId": result.payload[0].id,
                    //             //"ProjectCode": ProjectCode,
                    //             "ProjectCode": validateValue.projectCode,
                    //             "ProjectName": validateValue.projectName,
                    //             "AccountWorkTypeId": 0,
                    //             "Status": projectResponse.projectStatus.filter((x: any) => x.value === ProjectStatusId)[0].label,
                    //             "StartDate": StartDate,
                    //             "Deadline": Deadline
                    //         }
                    //     });
                    // }
                } else {
                     console.log('addAccountProject',result.payload)
                    if (result.payload.StatusCode === "417") {
                        setServerError(result.payload.message);
                    } else {
                        ShowToast('Error', result.payload.message, "error", "toast-top-right");
                    }
                    
                   
                }
            }).catch((error) => {
            });
        }
        else {
            let teamArray: any[] = [];
            addProjectTeamList.map((item: any) => {
                if (item.AccountProjectEmployeeId === 0) {
                teamArray.push({
                    "AccountEmployeeId": item.AccountEmployeeId, "isAdd": true, "AccountId": sessionAccountId
                })
            }
            });
            deletedProjectTeamList.map((item) => {
                teamArray.push({
                    "AccountEmployeeId": item.AccountEmployeeId, "isAdd": false
                })
            });
            let tempTeamCount = 0
            projectTeamList.map((item: any) => {
                item.IncludeTeam === 1 && (tempTeamCount = tempTeamCount + 1)
            });
            if (tempTeamCount === 0) {
                teamArray.push({
                    "AccountEmployeeId": sessionAccountEmployeeId, "isAdd": true, "AccountId": sessionAccountId
                })
            }
            let projectPrefix: string
            let tempProjectCode: string
            let splitProjectCode = validateValue.projectCode.split('-');
            if (includeCurrentYearInProjectCode) {
                tempProjectCode = validateValue.projectCode.split('-')[2];
                projectPrefix = projectCodePrefix == "" ? moment(new Date()).format('YYYY') : projectCodePrefix + '-' + moment(new Date()).format('YYYY');
            }
            else if (projectCodePrefix) {
                tempProjectCode = validateValue.projectCode.split('-')[1];
                projectPrefix = projectCodePrefix;
            }
            else {
                tempProjectCode = validateValue.projectCode;
            }
            // if (includeCurrentYearInProjectCode) {
            //     tempProjectCode = splitProjectCode.length == 1 ? validateValue.projectCode : validateValue.projectCode.split('-')[2];
            //     projectPrefix = projectCodePrefix == "" ? moment(new Date()).format('YYYY') : projectCodePrefix + '-' + moment(new Date()).format('YYYY');
            // } else {
            //     tempProjectCode = splitProjectCode.length == 1 ? validateValue.projectCode : validateValue.projectCode.split('-')[1];
            //     projectPrefix = projectCodePrefix == "" ? "" : projectCodePrefix;
            // }

                                                                // Normalize numeric values before creating object
            const normalizedDefaultBillingRate = parseLocalizedNumber(DefaultBillingRate);
            const normalizedDefaultFixedCost = parseLocalizedNumber(FixedCost);
            const normalizedProjectEstimatedCost = parseLocalizedNumber(ProjectEstimatedCost);
            let objectEdit = {
                AccountProject: {
                    ProjectName: validateValue.projectName,
                    AccountClientId: AccountClientId,
                    ProjectCode: tempProjectCode,
                    // LeaderEmployeeId: LeaderEmployeeId,
                    // ProjectManagerEmployeeId: ProjectManagerEmployeeId,
                    LeaderEmployeeId: selectedTL?.value,
                    ProjectManagerEmployeeId: selectedPM?.value,
                    AutoIncludeProjectEmployeesInTasks:  projectValues.AutoIncludeProjectEmployeesInTasks,
                    TimeSheetApprovalTypeId: TimesheetApprovalTypeId === 0 ? null : TimesheetApprovalTypeId,
                    ExpenseApprovalTypeId: ExpenseApprovalTypeId === 0 ? null : ExpenseApprovalTypeId,
                    DefaultBillingRate: normalizedDefaultBillingRate,
                    ProjectBillingTypeId: ProjectBillingTypeId,
                    ProjectBillingRateTypeId: ProjectBillingRateTypeId,
                    FixedCost: normalizedDefaultFixedCost,
                    isDisabled: isDisabled,
                    ProjectDescription: validateValue.projectDescription,
                    EstimatedDuration: parseLocalizedNumber(EstimatedDuration),
                    ProjectEstimatedCost: normalizedProjectEstimatedCost,
                    ProjectStatusId: ProjectStatusId,
                    AccountProjectTypeId: AccountProjectTypeId,
                    StartDate: moment(StartDate).format(dateInsertionFormat),
                    Deadline: moment(Deadline).format(dateInsertionFormat),
                    AccountPartyContactId: AccountClientContactId,
                    AccountPartyDepartmentId: AccountClientDepartmentId,
                    // ProjectPrefix: autoGenerateProjectCode ? projectPrefix : projectCodePrefix,
                CustomField1: getFormattedCustomField('CustomField1', validateValue.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', validateValue.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', validateValue.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', validateValue.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', validateValue.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', validateValue.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', validateValue.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', validateValue.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', validateValue.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', validateValue.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', validateValue.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', validateValue.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', validateValue.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', validateValue.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', validateValue.CustomField15)
                },
                Team: teamArray
            }
            dispatch(updateAccountProject(objectEdit)).then((result) => {
                // IsFromSummary && dispatch(getMethodFromTasksSlice(false));
                IsFromSummary && dispatch(reloadProjectSummaryTab());
                if (result.payload.constructor == Array) {
                    const accountProjectId = result.payload[0].id
                    const storedObject = localStorage.getItem('objProject');
                    let projectData = storedObject ? JSON.parse(storedObject) : {};
                    projectData.ProjectBillingRateTypeId = ProjectBillingRateTypeId;
                    projectData.ProjectName = validateValue.projectName;
                    projectData.ProjectCode = tempProjectCode;
                    projectData.Deadline = moment(Deadline).format(dateInsertionFormat);
                    projectData.StartDate = moment(StartDate).format(dateInsertionFormat);
                    localStorage.setItem('objProject', JSON.stringify(projectData));
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    ShowToast('Success', result.payload[0].message, "success", "toast-top-right");
                    if(pathName === '/accountprojecttemplates' || fromValue === 'projectTemplate'){
                        navigate(`/accountprojectsummary/${accountProjectId}?from=projectTemplate`)
                    }else{
                        navigate(`/accountprojectsummary/${accountProjectId}`)
                    }
                    // navigate(`/accountprojectsummary/${accountProjectId}`)
                    // setTimeout(() => {
                    //     if (closeButtonRef.current) {
                    //         closeButtonRef.current.click();
                    //     }
                    // }, 1000);
                } else {
                    console.log('addAccountProject',result.payload)
                    if (result.payload.StatusCode === "417") {
                        setServerError(result.payload.message);
                    } else {
                        ShowToast('Error', result.payload.message, "error", "toast-top-right");
                    }
                    
                }
            }).catch((error) => {
            });
        }
        clearAttachmentUpload();
        //resetAllFields();
    }

    const renderProjectTemplates = async (AccountProjectId: number) => {
        dispatch(updateIsLoading(true));
        const response = await fetchAPI('api/V2/Projects/GetProjectTemplateData?id=' + AccountProjectId, 'Get', '', true);
        const json = await response.json();
        let result = json[0].hasOwnProperty('Message');
        setProjectResponse((prevState: any) => {
            if ((prevState.clientName.findIndex((x: any) => x.value == json[0].AccountClientId)) == -1) {
                return {
                    ...prevState,
                    ['clientName']: [...prevState['clientName'], { value: json[0].AccountClientId, label: json[0].ClientName }]
                }
            } else if (prevState.teamLead.findIndex((x: any) => x.value == json[0].LeaderEmployeeId) == -1) {
                return {
                    ...prevState,
                    ['teamLead']: [...prevState['teamLead'], { value: json[0].LeaderEmployeeId, label: json[0].LeaderName }]
                }
            } else if (prevState.projectManager.findIndex((x: any) => x.value == json[0].ProjectManagerEmployeeId) == -1) {
                return {
                    ...prevState,
                    ['projectManager']: [...prevState['projectManager'], { value: json[0].ProjectManagerEmployeeId, label: json[0].ProjectManagerName }]
                }
            } else {
                return prevState;
            }
        });
        setprojectValues({
            ...projectValues,
            projectYup: {
                projectName: result ? '' : json[0].ProjectName,
                AccountProjectTemplateId: result ? '' : json[0].AccountProjectId,
                projectCode: result ? '' : (autoGenerateProjectCode ? autoProjectCode : json[0].ProjectCode),
                projectDescription: result ? '' : json[0].ProjectDescription
            },
            AccountClientId: result ? projectResponse.clientName[0].value : json[0].AccountClientId,
            // ProjectCode: result ? projectValues.ProjectCode : (autoGenerateProjectCode ? autoProjectCode : json[0].ProjectCode),
            LeaderEmployeeId: result ? projectResponse.teamLead[0].value : json[0].LeaderEmployeeId,
            ProjectManagerEmployeeId: result ? projectResponse.projectManager[0].value : json[0].ProjectManagerEmployeeId,
            TimesheetApprovalTypeId: result ? 0 : (json[0].TimeSheetApprovalTypeId != null ? json[0].TimeSheetApprovalTypeId : 0),
            ExpenseApprovalTypeId: result ? 0 : (json[0].ExpenseApprovalTypeId != null ? json[0].ExpenseApprovalTypeId : 0),
            DefaultBillingRate: result ? 0 : json[0].DefaultBillingRate,
            ProjectBillingTypeId: result ? projectResponse.billingType[0].value : json[0].ProjectBillingTypeId,
            ProjectBillingRateTypeId: result ? projectResponse.projectBillingRateType[0].value : json[0].ProjectBillingRateTypeId,
            FixedCost: result ? 0 : (json[0].FixedCost != null ? json[0].FixedCost : 0),
            // projectDescription: result ? '' : json[0].ProjectDescription,
            EstimatedDuration: result ? 0 : json[0].EstimatedDuration,
            ProjectEstimatedCost: result ? 0 : (json[0].ProjectEstimatedCost != null ? json[0].ProjectEstimatedCost : 0),
            ProjectStatusId: result ? projectResponse.projectStatus[0].value : json[0].ProjectStatusId,
            AccountProjectTypeId: result ? projectResponse.projectType[0].value : json[0].AccountProjectTypeId,
            // StartDate: result ? new Date() : new Date(json[0].StartDate),
            // Deadline: result ? new Date() : new Date(json[0].Deadline)
            StartDate: result ? new Date() : dateFormatByAccountCulture(json[0].StartDate, cultureInfoName.toString()),
            Deadline: result ? new Date() : dateFormatByAccountCulture(json[0].Deadline, cultureInfoName.toString())
        })
        dispatch(result ? getProjectTeam() : getSelectedProjectTeamMember(json[0].AccountProjectId));
        result && dispatch(updateIsLoading(false));
    }

    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    }

    const clearAttachmentUpload = () => {
        if (attachmentUploadClearRef.current) {
            attachmentUploadClearRef.current();
        }
    }

    const resetAllFields = () => {
        setTab('Basic');
        dispatch(resetProjectTeam());
        setprojectValues({
            ...projectValues,
            AccountClientId: 0,
            // ProjectCode: "",
            LeaderEmployeeId: 0,
            ProjectManagerEmployeeId: 0,
            TimesheetApprovalTypeId: 0,
            ExpenseApprovalTypeId: 0,
            DefaultBillingRate: 0,
            ProjectBillingTypeId: 0,
            ProjectBillingRateTypeId: 0,
            FixedCost: 0,
            projectDescription: "",
            EstimatedDuration: 0,
            ProjectEstimatedCost: 0,
            ProjectStatusId: 0,
            AccountProjectTypeId: 0,
            StartDate: '',
            Deadline: '',
            AccountClientContactId: 0,
            AccountClientDepartmentId: 0,
            AccountProjectId: 0,
            IsShowProjectTeam: true,
            projectYup: { projectName: "", projectCode: "", AccountProjectTemplateId: "" }
        })
    }

    const handleCloseOnClickEvent = () => {
        resetAllFields();
    }

    const handleChangeOption = (selected: any) => {
        setSelectedTL(selected);
    }

    const handleChangePM = (selected: any) => {
        setSelectedPM(selected);
    }

    const handleInputTeam = (inputValue: string) => {
        setSearch(inputValue);
        setIsSearchTL(true);
    }

    const handleInputPM = (inputValue: string) => {
        setSearch(inputValue);
        setIsSearchPM(true);
    }

    const validationSchema = yup.object().shape(isFromTemplate && isProjectTemplateMandatory ? {
        projectName: yup
        .string()
        .label(getValueFromResource('Project Name', dispatch, t))
        .required(getValueFromResource('Project Name is required', dispatch, t))
        .max(600, getValueFromResource('Project Name must not exceed 600 Characters', dispatch, t)),
        projectDescription: yup
        .string()
        .label(getValueFromResource('Project Description', dispatch, t))
        .max(4000, getValueFromResource('Project Description must not exceed 4000 Characters', dispatch, t)),
        projectCode: yup
        .string()
        .label(getValueFromResource('Project Code', dispatch, t))
        .max(100, getValueFromResource('Project Code must not exceed 100 Characters', dispatch, t)),
        EstimatedDuration: yup
                    .string() 
                    .label(getValueFromResource('Estimate dDuration', dispatch, t))
                    .trim()          
                    .test(
                        'culture-format-check',
                        () => {
                            const isComma = determineCommaSeprater(cultureInfoName.toString());
                            return isComma
                                ? "Only numbers and comma (,) are allowed."
                                : "Only numbers and dot (.) are allowed.";
                        },
                        (value) => {
                            if (!value) return true; 
                            const isComma = determineCommaSeprater(cultureInfoName.toString());
                            if (isComma) {
                                return /^\d+(,\d+)?$/.test(value); 
                            } else {
                                return /^\d+(\.\d+)?$/.test(value); 
                            }
                        }
                    )
                    .test(
                        'positive-check',
                        getValueFromResource('Duration must be a positive number', dispatch, t),
                        (value) => {
                            if (!value) return true; // allow empty
                            const isComma = determineCommaSeprater(cultureInfoName.toString());
                            const numericValue = isComma
                                ? parseFloat(value.replace(',', '.'))
                                : parseFloat(value);
                            return numericValue >= 0;
                        }
                    )
                    .nullable(),        
    AccountProjectTemplateId: yup
        .string()
        .label(getValueFromResource('Project Templates', dispatch, t))
        .required(getValueFromResource('Project Templates is required', dispatch, t)),
        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        yupSchema = yup.string().trim();
                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    return [x.DatabaseFieldName, yupSchema];
                })
        ),
        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        yupSchema = yup.string().trim();
                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    return [x.DatabaseFieldName, yupSchema];
                })
        )
    } : {
        projectName: yup
        .string()
        .label(getValueFromResource('Project Name', dispatch, t))
        .required(getValueFromResource('Project Name is required', dispatch, t))
        .max(600, getValueFromResource('Project Name must not exceed 600 Characters', dispatch, t)),
        projectDescription: yup
        .string()
        .label(getValueFromResource('Project Description', dispatch, t))
        .max(4000, getValueFromResource('Project Description must not exceed 4000 Characters', dispatch, t)),
    projectCode: yup
        .string()
        .label(getValueFromResource('Project Code', dispatch, t))
        .max(100, getValueFromResource('Project Code must not exceed 100 Characters', dispatch, t)),
        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        yupSchema = yup.string().trim();
                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    return [x.DatabaseFieldName, yupSchema];
                })
        ),
        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        yupSchema = yup.string().trim();
                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    return [x.DatabaseFieldName, yupSchema];
                })
        )
    });

    const handleBlurValidateAll = (setFieldTouched: any, values: any, validateForm: any) => {
        // Mark all fields as touched
        Object.keys(values).forEach(field => {
            setFieldTouched(field, true);
        });
        // Validate all fields
        validateForm();
    }

    return (
        <>
            <Formik
               innerRef={formikRef}
                initialValues={projectValues.projectYup}
                enableReinitialize={true}
                onSubmit={values => onAddUpdateProject(values)}
                validationSchema={validationSchema}
                
            // validationSchema={yup.object().shape(isFromTemplate && isProjectTemplateMandatory ? {
            //     projectName: yup
            //         .string()
            //         .label('Project Name')
            //         .required()
            //         .max(600, 'Project Name must not exceed 600 Characters'),
            //     projectDescription: yup
            //         .string()
            //         .label('Project Description')
            //         .required()
            //         .max(4000, 'Project Description must not exceed 4000 Characters'),
            //     projectCode: yup
            //         .string()
            //         .label(t('Project Code'))
            //         .required()
            //         .max(100, 'Project Code must not exceed 100 Characters'),
            //     AccountProjectTemplateId: yup
            //         .string()
            //         .label('Project Templates')
            //         .required()
            // } : {
            //     projectName: yup
            //         .string()
            //         .label('Project Name')
            //         .required()
            //         .max(600, 'Project Name must not exceed 600 Characters'),
            //     projectDescription: yup
            //         .string()
            //         .label('Project Description')
            //         .required()
            //         .max(4000, 'Project Description must not exceed 4000 Characters'),
            //     projectCode: yup
            //         .string()
            //         .label(t('Project Code'))
            //         .required()
            //         .max(100, 'Project Code must not exceed 100 Characters'),
            // }
            // )}
            >
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm }) => (
                    <Fragment>
                        <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                            {projectValues.isCanvasLoader ? <CanvasLoader /> : <>
                                <div className='row'>
                                    {isFromTemplate &&
                                        <div className="col-md-6">
                                            <label className="form-label fs-7 fw-normal mb-2">
                                                {/* {t('Project Template')} */}
                                                {getValueFromResource('Project Template',dispatch, t)}
                                                </label>
                                            <Select
                                                value={projectResponse.projectTemplates.filter((x: any) => x.value == values.AccountProjectTemplateId)}
                                                className="basic-single fs-7 fw-normal"
                                                classNamePrefix="select"
                                                name="AccountProjectTemplateId"
                                                //onBlur={() => setFieldTouched('AccountProjectTemplateId', true)}
                                                onChange={(selectedOption) => {
                                                    handleChange({
                                                        target: {
                                                            id: "AccountProjectTemplateId",
                                                            value: selectedOption?.value
                                                        }
                                                    });
                                                    renderProjectTemplates(selectedOption.value != '' ? selectedOption.value : 0);
                                                }}
                                                options={projectResponse.projectTemplates}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            />
                                            <div>
                                                {touched.AccountProjectTemplateId && errors.AccountProjectTemplateId &&
                                                    <p className='errorMsg'>{errors.AccountProjectTemplateId as string}</p>
                                                }
                                            </div>
                                        </div>
                                    }
                                    <div className={clsx(isFromTemplate ? 'col-md-6' : 'col-md-12')}>
                                        <label className="required form-label fs-7 fw-normal mb-2"
                                        >
                                        {/* {t('Project Name')} */}
                                        {getValueFromResource('Project Name',dispatch, t)}
                                        </label>
                                        <input
                                            value={values.projectName}
                                            type="text"
                                            className="form-control fs-7 fw-normal"
                                            placeholder=
                                            // {t('Project Name')}
                                            {getValueFromResource('Project Name',dispatch, t)}
                                            autoCapitalize="none"
                                            onChange={handleChange('projectName')}
                                            ref={defaultFocusRef}
                                            // onBlur={() => setFieldTouched('projectName')}
                                        // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                        />
                                        <div>
                                            {touched.projectName && errors.projectName &&
                                                <p className='errorMsg'>{errors.projectName as string}</p>
                                            }

                                            {serverError && (
                                                <p className='errorMsg'>{serverError}</p>
                                            )}
                                                                                    </div>
                                    </div>
                                </div>
                                <div className='card-header' style={{ marginLeft: '-30px' }}>
                                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-4' role='tablist'>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Basic' })}
                                                onClick={() => setTab('Basic')}
                                                role='tab'
                                            >
                                                {/* {t('Basic')} */}
                                                {getValueFromResource('Basic',dispatch, t)}
                                            </a>
                                        </li>
                                        {projectValues.IsShowProjectTeam && <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Team' })}
                                                onClick={() => setTab('Team')}
                                                role='tab'
                                            >
                                                {/* {t('Team')} */}
                                                {getValueFromResource('Team',dispatch, t)}
                                            </a>
                                        </li>
                                        }
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Approvals' })}
                                                onClick={() => setTab('Approvals')}
                                                role='tab'
                                            >
                                                {/* {t('Approvals')} */}
                                                {getValueFromResource('Approvals',dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Billing' })}
                                                onClick={() => setTab('Billing')}
                                                role='tab'
                                            >
                                                {/* {t('Billing')} */}
                                                {getValueFromResource('Billing',dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Advanced' })}
                                                onClick={() => setTab('Advanced')}
                                                role='tab'
                                            >
                                                {/* {t('Advanced')} */}
                                                {getValueFromResource('Advanced',dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Others' })}
                                                onClick={() => setTab('Others')}
                                                role='tab'
                                            >
                                                {/* {t('Others')} */}
                                                {getValueFromResource('Others',dispatch, t)}
                                            </a>
                                        </li>
                                        { enableUploadFeature &&
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Attachment' })}
                                                onClick={() => setTab('Attachment')}
                                                role='tab'
                                            >
                                                {/* {t('Attachment')} */}
                                                {getValueFromResource('Attachment',dispatch, t)}
                                            </a>
                                        </li>}
                                        {customFieldsArray && customFieldsArray.length > 0 &&
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'CustomField' })}
                                                    onClick={() => setTab('CustomField')}
                                                    role='tab'
                                                >
                                                    {/* {t('Custom Field')} */}
                                                    {getValueFromResource('Custom Field',dispatch, t)}
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <div className='tab-content pt-6'>
                                    <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Client Name')} */}
                                                    {getValueFromResource('Client Name',dispatch, t)}
                                                    </label>
                                                <Select
                                                    value={projectResponse.clientName.filter((x: any) => x.value == projectValues.AccountClientId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="clientArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.clientName}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            {/* <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">{t('Project Code')}</label>
                                                <input
                                                    type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    name="ProjectCode"
                                                    value={projectValues.ProjectCode}
                                                    onChange={onHandleTextChange}
                                                    readOnly={autoGenerateProjectCode ? true : false}
                                                />
                                            </div> */}
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t(`Project Code`)} */}
                                                    {getValueFromResource('Project Code',dispatch, t)}
                                                    </label>                                               
                                                
                                                {/* <input
                                                    type="text"
                                                    name="projectCode"
                                                    className="form-control fs-7 fw-normal"
                                                    id="projectCode"                                                  
                                                    value={
                                                       values.ProjectPrefix
                                                            ? (autoGenerateProjectCode && accountprojectid == 0 ? autoProjectCode : `${values.ProjectPrefix}-${values.projectCode || ''}`)
                                                            : values.projectCode || ''
                                                    }
                                                    
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        if (values.ProjectPrefix) {
                                                            const prefixWithDash = `${values.ProjectPrefix}-`; 
                                                            if (val.startsWith(prefixWithDash)) {
                                                                val = val.slice(prefixWithDash.length);
                                                            }
                                                        }
                                                        val = val.trimStart();
                                                        setFieldValue('projectCode', val);
                                                    }}
                                                    readOnly={autoGenerateProjectCode}
                                                    onBlur={() =>
                                                        handleBlurValidateAll(setFieldTouched, values, validateForm)
                                                    }
                                                /> */}
                                                <input
                                                    ref={projectCodeRef}
                                                    type="text"
                                                    name="projectCode"
                                                    className="form-control fs-7 fw-normal"
                                                    id="projectCode"
                                                    value={
                                                        values.ProjectPrefix
                                                            ? (autoGenerateProjectCode && accountprojectid == 0
                                                                ? autoProjectCode
                                                                : `${values.ProjectPrefix}-${values.projectCode || ''}`)
                                                            : values.projectCode || ''
                                                    }
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        const prefix = values.ProjectPrefix;
                                                        const prefixWithDash = prefix ? `${prefix}-` : '';

                                                        if (prefix) {
                                                            val = val.replaceAll(prefixWithDash, '');
                                                            val = val.replace(new RegExp(`^${prefix}`, 'i'), '');
                                                        }

                                                        setFieldValue('projectCode', val);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (!values.ProjectPrefix) return;

                                                        const input = projectCodeRef.current;
                                                        if (!input) return;

                                                        const prefixLength = `${values.ProjectPrefix}-`.length;
                                                        const cursorPos = input.selectionStart ?? 0;
                                                        if (
                                                            (e.key === 'ArrowLeft' && cursorPos <= prefixLength) ||
                                                            (e.key === 'Backspace' && cursorPos <= prefixLength)
                                                        ) {
                                                            e.preventDefault();
                                                            input.selectionStart = input.selectionEnd = prefixLength;
                                                        }
                                                    }}
                                                    onClick={() => {
                                                        const input = projectCodeRef.current;
                                                        if (input && values.ProjectPrefix) {
                                                            const pos = `${values.ProjectPrefix}-`.length;
                                                            if (input.selectionStart! < pos) {
                                                                input.selectionStart = input.selectionEnd = pos;
                                                            }
                                                        }
                                                    }}
                                                    readOnly={autoGenerateProjectCode}
                                                    onBlur={() =>
                                                        handleBlurValidateAll(setFieldTouched, values, validateForm)
                                                    }
                                                />



                                                <div>
                                                    {touched.projectCode && errors.projectCode &&
                                                        <p className='errorMsg'>{errors.projectCode as string}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Team Lead')} */}
                                                    {getValueFromResource('Team Lead', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource("Select an employee to assign as the Team Lead. This role can be configured to approve Timesheets and Expenses in TimeLive.", dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div onScroll={handleScroll}>
                                                    <Select
                                                        value={selectedTL}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="teamLeadArray"
                                                        onChange={handleChangeOption}
                                                        options={dataTL}
                                                        styles={dropDownSelectionStyles}
                                                        maxMenuHeight={maxMenuHeight}
                                                        onInputChange={handleInputTeam}
                                                        components={{ MenuList: customMenuList }}
                                                         menuPlacement="auto"
                                                        menuPosition="fixed" 
                                                    />
                                                </div>
                                                {/* <Select
                                                value={projectResponse.teamLead.filter((x: any) => x.value == projectValues.LeaderEmployeeId)}
                                                className="basic-single fs-7 fw-normal"
                                                classNamePrefix="select"
                                                name="teamLeadArray"
                                                onChange={(e, name) => onChange(e, name)}
                                                options={projectResponse.teamLead}
                                                styles={dropDownSelectionStyles}
                                                maxMenuHeight={maxMenuHeight}
                                            /> */}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Project Manager')} */}
                                                    {getValueFromResource('Project Manager', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Select an employee to assign as the Project Manager. This role can be configured to approve Timesheets and Expenses in TimeLive.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div onScroll={handleScroll}>
                                                    <Select
                                                        value={selectedPM}
                                                        className="basic-single fs-7 fw-normal"
                                                        classNamePrefix="select"
                                                        name="teamLeadArray"
                                                        onChange={handleChangePM}
                                                        options={dataPM}
                                                        styles={dropDownSelectionStyles}
                                                        onInputChange={handleInputPM}
                                                        maxMenuHeight={maxMenuHeight}
                                                        components={{ MenuList: customMenuList }}
                                                        menuPlacement="auto"
                                                        menuPosition="fixed" 
                                                    />
                                                </div>
                                                {/* <Select
                                                    value={projectResponse.projectManager.filter((x: any) => x.value == projectValues.ProjectManagerEmployeeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="projectManagerArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.projectManager}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                /> */}
                                            </div>
                                        </div>

                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t(`All Project Employee Task`)} */}
                                                    {getValueFromResource('Auto Include Project Employees In Tasks', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Determines whether project employees are automatically included in project tasks.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                    </div>
                                                </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input
                                                        className="form-check-input h-20px w-30px"
                                                        type='checkbox'
                                                        name='AutoIncludeProjectEmployeesInTasks'
                                                        checked={projectValues.AutoIncludeProjectEmployeesInTasks}
                                                        onChange={(e) => { onSwitch(e) }}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                      
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Team' })}>
                                        <ProjectResource name="ProjectTeam" />
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Approvals' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Timesheet Approval Type')} */}
                                                    {getValueFromResource('Timesheet Approval Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Defines the approval workflow used for timesheets submitted against this project.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={projectResponse.timesheetApprovalType.filter((x: any) => x.value == projectValues.TimesheetApprovalTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="timesheetApprovalTypeArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.timesheetApprovalType}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Expense Approval Type')} */}
                                                    {getValueFromResource('Expense Approval Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Defines the approval workflow used for expenses submitted against this project.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={projectResponse.expenseApprovalType.filter((x: any) => x.value == projectValues.ExpenseApprovalTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="expenseApprovalTypeArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.expenseApprovalType}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Billing' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Default Billing Rate')} */}
                                                    {getValueFromResource('Default Billing Rate', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('The standard billing rate applied to project work unless overridden by employee, task, or billing rules.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    name='DefaultBillingRate'
                                                    value={projectValues.DefaultBillingRate}
                                                    //onChange={onHandleTextChange}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            setprojectValues({...projectValues, DefaultBillingRate: val});
        }
        //setprojectValues({...projectValues, DefaultBillingRate: val});
    }}
    onBlur={(e) => {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        setprojectValues({...projectValues, DefaultBillingRate: formatted});
    }}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Project Billing Type')} */}
                                                    {getValueFromResource('Project Billing Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Determines how the project is billed, such as Fixed Bid or Per Hour.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={projectResponse.billingType.filter((x: any) => x.value == projectValues.ProjectBillingTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="projectBillingTypeArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.billingType}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Billing Rate Type')} */}
                                                    {getValueFromResource('Billing Rate Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Specifies how billing rates are determined for the project, such as Project Rate, Employee Rate, Task Rate, or another configured method.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={projectResponse.projectBillingRateType.filter((x: any) => x.value == projectValues.ProjectBillingRateTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="billingRateTypeArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.projectBillingRateType}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Fixed Cost')} */}
                                                    {getValueFromResource('Fixed Cost', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Enter the agreed fixed contract amount for projects billed at a fixed price.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    name='FixedCost'
                                                    value={projectValues.FixedCost}
                                                    //onChange={onHandleTextChange}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            setprojectValues({...projectValues, FixedCost: val});
        }
        //setprojectValues({...projectValues, FixedCost: val});
    }}
    onBlur={(e) => {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        setprojectValues({...projectValues, FixedCost: formatted});
    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Advanced' })}>
                                        <div className='row'>
                                            {/* <div className="col-md-12">
                                                <label className="form-label fs-7 fw-normal mb-2">{t('Project Description')}</label>
                                                <textarea
                                                    value={projectValues.ProjectDescription}
                                                    name="ProjectDescription"
                                                    className="form-control fs-7 fw-normal"
                                                    rows={4}
                                                    onChange={onHandleTextChange}
                                                >
                                                </textarea>
                                            </div> */}
                                            <div className="col-md-12">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Project Description')} */}
                                                    {getValueFromResource('Project Description',dispatch, t)}
                                                    </label>
                                                <textarea
                                                    value={values.projectDescription}
                                                    name="projectDescription"
                                                    className="form-control fs-7 fw-normal"
                                                    rows={4}
                                                    onChange={handleChange('projectDescription')}
                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                ></textarea>
                                                <div>
                                                    {touched.projectDescription && errors.projectDescription &&
                                                        <p className='errorMsg'>{errors.projectDescription as string}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Duration')} */}
                                                    {/* {getValueFromResource('Duration',dispatch, t)} */}
                                                    {getValueFromResource('Estimated Duration', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('The planned length of the project, used for scheduling, forecasting, and progress tracking.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div className="wrapper">
                                                    <div className="innerTextField">
                                                        {/* {t(`Hours`)} */}
                                                        {getValueFromResource('Hours',dispatch, t)}
                                                        </div>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        name='EstimatedDuration'
                                                        value={projectValues.EstimatedDuration}
                                                        onChange={onHandleTextChange}
                                                    />
                                                </div>
                                                 <div>
                                                    {touched.EstimatedDuration && errors.EstimatedDuration &&
                                                        <p className='errorMsg'>{errors.EstimatedDuration as string}</p>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Project Estimated Cost')} */}
                                                    {getValueFromResource('Project Estimated Cost', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('The projected total cost of completing the project based on planned resources and expenses.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control fs-7 fw-normal"
                                                    name='ProjectEstimatedCost'
                                                    value={projectValues.ProjectEstimatedCost}
                                                    //onChange={onHandleTextChange}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            setprojectValues({...projectValues, ProjectEstimatedCost: val});
        }
        //setprojectValues({...projectValues, FixedCost: val});
    }}
    onBlur={(e) => {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        setprojectValues({...projectValues, ProjectEstimatedCost: formatted});
    }}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Project Status')} */}
                                                    {getValueFromResource('Project Status', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Indicates the current lifecycle stage of the project, such as Planning, Active, On Hold, Completed, or Closed.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={projectResponse.projectStatus.filter((x: any) => x.value == projectValues.ProjectStatusId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="projectStatusArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.projectStatus}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Project Type')} */}
                                                    {getValueFromResource('Project Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Categorizes the project for reporting and management.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={projectResponse.projectType.filter((x: any) => x.value == projectValues.AccountProjectTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="projectTypeArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.projectType}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Others' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Start Date')} */}
                                                    {getValueFromResource('Start Date',dispatch, t)}
                                                    </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={projectValues.StartDate}
                                                        onChange={(date) => onDateChange(date, "StartDate")}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('End Date')} */}
                                                    {getValueFromResource('End Date',dispatch, t)}
                                                    </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={projectValues.Deadline}
                                                        onChange={(date) => onDateChange(date, "DeadlineDate")}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row'>

                                            <div className="col-md-6 mt-3">
                                                {accountprojectid !== 0 ? (
                                                    <div className="col-md-12">
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {t('Disabled')} */}
                                                            {getValueFromResource('Disabled',dispatch, t)}
                                                            </label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input
                                                                className="form-check-input h-20px w-30px  mt-2"
                                                                type='checkbox'
                                                                name='isDisabled'
                                                                checked={projectValues.isDisabled}
                                                                onChange={(e) => { onSwitch(e) }}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {showClientDepartmentInProject && <div className='row spacingBetweenRows'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Client Contact')} */}
                                                    {getValueFromResource('Client Contact',dispatch, t)}
                                                    </label>
                                                <Select
                                                    value={projectResponse.clientContact.filter((x: any) => x.value == projectValues.AccountClientContactId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="clientContactArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.clientContact}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Client Department')} */}
                                                    {getValueFromResource('Client Department',dispatch, t)}
                                                    </label>
                                                <Select
                                                    value={projectResponse.ClientDepartment.filter((x: any) => x.value == projectValues.AccountClientDepartmentId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="clientDepartmentArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={projectResponse.ClientDepartment}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>}
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Attachment' })}>
                                        <AttachmentUpload
                                            Id={Number(accountprojectid)}
                                            onupdateTempAttachmentId={updateTempAttachmentId}
                                            clearRef={attachmentUploadClearRef}
                                            AccountAttachmentTypeId={4}
                                        />
                                        {tab === 'Attachment' && (Number(accountprojectid) && Number(accountprojectid) !== 0) ? (
                                            <GetAttachments Id={Number(accountprojectid)} AccountAttachmentTypeId={4} IsShowEmployeeInformation={false} isDisabled={true} />
                                        ) : null}
                                    </div>
                                    {customFieldsArray && customFieldsArray.length > 0 &&
                                        <div className={clsx('tab-pane', { active: tab === 'CustomField' })}>
                                            <div className='row'>
                                                {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                                    <Fragment key={index}>
                                                        {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                            <>
                                                                <div key={index} className={"col-md-6 mb-3 "}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <Select
                                                                        name={x.DatabaseFieldName}
                                                                        className="basic-single fs-7 fw-normal"
                                                                        styles={dropDownSelectionStyles}
                                                                        onChange={(e: any) => setFieldValue(x.DatabaseFieldName, e?.value)}
                                                                        value={values[x.DatabaseFieldName] ? { value: values[x.DatabaseFieldName], label: values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                                        options={[
                                                                            { value: 'None', label: 'None' },  
                                                                            ...x.DropDownOptions
                                                                                ? x.DropDownOptions.split("+").map((value: any) => ({ value, label: value }))
                                                                                : []
                                                                        ]}
                                                                       // options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                                        maxMenuHeight={maxMenuHeight}
                                                                    />
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>

                                                            </>
                                                        )}
                                                        {x.MasterCustomDataTypeName == "Date" && (
                                                            <>
                                                                <div key={index} className={"col-md-6 mb-3"}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <div className="wrapper">
                                                                    <DatePicker
                                                                        name={x.DatabaseFieldName}
                                                                        //onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                        //selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                        onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(customFieldInsertionFormat) : new Date())}
                                                                        selected={(values[x.DatabaseFieldName] ? dateFormatByAccountCulture(values[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                                        calendarStartDay={calendarStartDay}
                                                                        className="form-control form-con fs-7 fw-normal col-md-1"
                                                                        onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                    />
                                                                     <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                                    </div>
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFxieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                        {(x.MasterCustomDataTypeName == "Text") && (
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <input
                                                                    name={x.DatabaseFieldName}
                                                                    id={x.DatabaseFieldName}
                                                                    value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                    onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                    className={"form-control form-con input-sm custom-field custom-field"}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                    type="text"
                                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {(x.MasterCustomDataTypeName == "Number") && (
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <input
                                                                    name={x.DatabaseFieldName}
                                                                    id={x.DatabaseFieldName}
                                                                    value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                                setFieldValue(x.DatabaseFieldName, value);
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            const formatted = formatNumberCustomoriginal(
                                                                                cultureInfoName.toString(),
                                                                                e.target.value,
                                                                                decimalPlaces
                                                                            );
                                                                            setFieldValue(x.DatabaseFieldName, formatted);
                                                                        }}
                                                                    //onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                    className={"form-control form-con input-sm custom-field custom-field"}
                                                                    //max={x.MaximumValue !== undefined ? parseFloat(x.MaximumValue) : undefined}
                                                                    //min={x.MinimumValue !== undefined ? parseFloat(x.MinimumValue) : undefined}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                    type="text"
                                                                    //onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Fragment>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>}
                            {showErrorSummary && Object.keys(errors).length > 0 && (
                                <div className="mt-3 alert alert-danger">
                                    <strong>
                                        {/* {t('Error Summary')}: */}
                                        {getValueFromResource('Error Summary',dispatch, t)}:
                                        </strong>
                                    <ul>
                                        {Object.keys(errors).map((fieldName, index) => (
                                            <li key={index}>{errors[fieldName] as string}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-end'>
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                    onClick={handleCloseOnClickEvent}
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel',dispatch, t)}
                                </button>
                                <button
                                    className='btn btn-sm btn-primary'
                                    type='button'
                                    data-kt-element='send'
                                    // onClick={() => handleSubmit()}
                                    onClick={() => { setShowErrorSummary(true); 
                                        handleSubmit();
                                    }}
                                    //disabled={!isValid}
                                    //disabled={IsLicenseExpired === "true" ? true : false}
                                    disabled={IsLicenseExpired === "true" && accountprojectid === 0}
                                >
                                    {/* <KTIcon iconName='plus' className='fs-3' /> */}
                                    {/* {t('Save')} */}
                                    {getValueFromResource('Save',dispatch, t)}
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
             
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}

export default ProjectAddUpdate